// extracted by mini-css-extract-plugin
module.exports = {"emailInput":"SendPreviewForm_emailInput__2Qo-Y","button":"SendPreviewForm_button__2fObL","active":"SendPreviewForm_active__2GMFV","inactive":"SendPreviewForm_inactive__1Yfxw"};